import { ActionTypes, handleActionCompleted } from './actions';
import * as signalR from "@microsoft/signalr";
import * as FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
// single signalR connection-per-page
export const connection = new signalR.HubConnectionBuilder()
  .withUrl("/defaultHub")
  .withAutomaticReconnect()
  // .configureLogging(signalR.LogLevel.Debug)
  .build();
import { startBuildingBars, subscribeToInstrumentsUpdate } from "./instruments";
import { ReportData, ReportUtils } from "./reports";
import { Toaster } from "./toaster";
declare var OneSignal: any;
declare var gonative: any;

$(() => {
  connection.on("Error",
    (code: number, message: string) => {
      Toaster.error(message);
      if (code === 42) {
        $("#reconnect-to-stream-modal").modal("show");
      }
    });

  connection.on("ConnectedToStream",
    () => {
      console.log("connected to stream");
      $("#reconnect-to-stream-modal").modal("hide");
      const returnUrl = $("#sign-up-return-url").val() as string;
      if (returnUrl) {
        window.location.href = returnUrl;
      }
    });

  connection.on("ConnectionNotAllowed",
    () => {
      window.location.href = '/connection-not-allowed';
    });

  connection.on("LogoutUser",
    (reason: string) => {
      const href = reason ? `/logout?reason=${reason}` : '/logout';
      window.location.href = href;
    });

  connection.on("ForceRedirect",
    (url: string) => {
      window.location.href = url;
    });

  connection.on("OnEDDTradesBlockedLevel1",
    () => {
      Toaster.tradeError(
        'Trade is blocked by EDD.',
        () => { window.location.href = '/registration/sourceoffunds'; });
    });

  connection.on("OnEDDTradesBlockedLevel2",
    (limitLvl2: string) => {
      Toaster.alert(
        'Your request for increased Payment limits has been received and being processed. Current monthly deposit/withdrawal limit: ' + limitLvl2);
    });

  connection.on("Info",
    (message: string) => {
      Toaster.info(message);
    });

  connection.on("ForceLogoutUser",
    (message: string) => {
      Toaster.error(message);
    });

  connection.on("TradeError",
    (code: number, message: string) => {
      console.error("trade error:", code);
      Toaster.tradeError(message);
    });

  connection.on("TradeSuccess",
    (title: string, message: string) => {
      Toaster.tradeSuccess(title, message);
    });

  connection.on("TradeInfo",
    (title: string, message: string) => {
      Toaster.tradeInfo(title, message);
    });

  connection.on("OnExecutionReport",
    (report: ReportData) => {
      if (ReportUtils.isError(report)) {
        Toaster.tradeError(report.text);
        return;
      }

      Toaster.tradeInfo("Execution Report", ReportUtils.formatMessage(report));
    });

  connection.on("OnActionCompleted",
    (actionType: ActionTypes, actionId: string, text: string) => {
      handleActionCompleted(actionType, actionId, text);
    });

  subscribeToInstrumentsUpdate(connection);

  if (connection.state === 'Disconnected') { // connection can be opened by component
    connection.start()
      .then(() => {
        console.log("connection started");
        setVisitorId();
        setOneSignalPlayerIds();
      })
      .catch((error) => {
        console.error(error.toString());
        Toaster.error("Failed to connect to server");
      });
  }

  startBuildingBars();

  connection.onclose((error?: Error) => {
    if (error) {
      console.error('connection was closed: ', error);
    } else {
      console.error('connection was closed');
    }
  });

  $("#reconnect-to-stream-btn").on("click", () => {
    connection.invoke("ReconnectStreamClient").catch((error) => {
      console.error(error.toString());
      Toaster.error(error.toString());
    });
  });

  // clear state on show
  $("#trade-modal").on("show.bs.modal", function (e) {
    $("#tradeInstrument").removeClass("is-invalid");
    $("#validationInstrumentFeedback").text("");

    $("#tradeQty").val("");
    $("#tradeQty").removeClass("is-invalid");
    $("#validationQtyFeedback").text("");

    $("#tradeLimitPx").val("");
    $("#tradeLimitPx").removeClass("is-invalid");
    $("#validationLimitPxFeedback").text("");

    $("#tradeStopPx").val("");
    $("#tradeStopPx").removeClass("is-invalid");
    $("#validationStopPxFeedback").text("");
  });

  $("#tradeQty").on("focus", function () {
    $("#tradeQty").removeClass("is-invalid");
    $("#validationQtyFeedback").text("");
  });

  $("#tradeLimitPx").on("focus", function () {
    $("#tradeLimitPx").removeClass("is-invalid");
    $("#validationLimitPxFeedback").text("");
  });

  $("#tradeStopPx").on("focus", function () {
    $("#tradeStopPx").removeClass("is-invalid");
    $("#validationStopPxFeedback").text("");
  });

  $("#tradeSendOrder").on("click", function (e) {
    const instrument = $("#tradeInstrument").val() as string;
    if (!instrument) {
      $("#tradeInstrument").addClass("is-invalid");
      $("#validationInstrumentFeedback").text("Invalid instrument.");
      return;
    }

    let tradeQty = $("#tradeQty").val();
    tradeQty = tradeQty?.toString().replaceAll(',', '');
    const qty = parseFloat(tradeQty as string);
    if (isNaN(qty) || qty <= 0) {
      $("#tradeQty").addClass("is-invalid");
      $("#validationQtyFeedback").text("Invalid quantity.");
      return;
    }

    const tradeOrderType = $("#tradeOrderType").val() as string;
    const tradeTimeInForce = $("#tradeTimeInForce").val() as string;
    const tradeAlgoId = $("#tradeAlgoId").val() as string;
    const tradeRoute = $("#tradeRoute").val() as string;

    let limitPx = $("#tradeLimitPx").val();
    limitPx = limitPx?.toString().replaceAll(',', '');
    const tradeLimitPx = parseFloat(limitPx as string);
    if ((tradeOrderType == "limitBuy" || tradeOrderType == "limitSell") && (isNaN(tradeLimitPx) || tradeLimitPx <= 0)) {
      $("#tradeLimitPx").addClass("is-invalid");
      $("#validationLimitPxFeedback").text("Invalid limit price.");
      return;
    }

    let stopPx = $("#tradeStopPx").val();
    stopPx = stopPx?.toString().replaceAll(',', '');
    const tradeStopPx = parseFloat(stopPx as string);
    if ((tradeOrderType == "stopSell" || tradeOrderType == "stopBuy") && (isNaN(tradeStopPx) || tradeStopPx <= 0)) {
      $("#tradeStopPx").addClass("is-invalid");
      $("#validationStopPxFeedback").text("Invalid stop price.");
      return;
    }

    if (!tradeLimitPx && (tradeOrderType == "limitBuy" || tradeOrderType == "limitSell")) {
      $("#tradeLimitPx").addClass("is-invalid");
      $("#validationLimitPxFeedback").text("Enter limit price.");
      return;
    }
    if (!tradeStopPx && (tradeOrderType == "stopBuy" || tradeOrderType == "stopSell")) {
      $("#tradeStopPx").addClass("is-invalid");
      $("#validationStopPxFeedback").text("Enter stop price.");
      return;
    }

    const orderDetails = {
      instrument: instrument,
      orderType: tradeOrderType,
      quantity: qty,
      timeInForce: tradeTimeInForce,
      algoId: tradeAlgoId,
      route: tradeRoute,
      limitPrice: limitPx,
      stopPrice: stopPx
    };

    console.log("Send order with details: ", orderDetails);
    $("#trade-modal").modal("hide");

    connection.invoke("SendOrder", orderDetails)
      .catch((err) => {
        console.error(err.toString());
        Toaster.error(err.toString());
      });
  });
});

export function setVisitorId() {
  const fpPromise = FingerprintJS.load({ apiKey: 'fmlKGcRe6xLZHIIdBSYa', region: 'eu' });
  fpPromise
    .then(fp => fp.get())
    .then(result => {
      connection
        .invoke("SetVisitorId", result.visitorId)
        .catch((error) => console.error(error.toString()));
    })
    .catch(err => console.error(err));
}

export function setOneSignalPlayerIds() {
  if (typeof OneSignal !== "undefined") {
    console.log('updating OneSignal IDs');

    OneSignal.push(function () {
      OneSignal.getUserId(function (playerId: string) {
        connection.invoke("SetOneSignalWebPushPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    OneSignal.push(function () {
      OneSignal.getEmailId(function (playerId: string) {
        connection.invoke("SetOneSignalEmailPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    OneSignal.push(function () {
      OneSignal.getSMSId(function (playerId: string) {
        connection.invoke("SetOneSignalSMSPlayerId", playerId)
          .catch((error) => console.error(error.toString()));
      });
    });

    if (typeof gonative !== "undefined") {
      gonative.onesignal.onesignalInfo().then(function (oneSignalInfo) {
        connection.invoke("SetOneSignalMobilePlayerId", JSON.stringify(oneSignalInfo))
          .catch((error) => console.error(error.toString()));
      });
    }
  }
}
